"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateToken = void 0;
const buffer_1 = require("buffer");
const tweetnacl_1 = require("tweetnacl");
const CotterPublicKey = "qqOaiQGjGsxBMgI5rdAasaACRiJthOqadmefjY5mS/c=";
const ValidateToken = (message, signature) => {
    const messageUint8 = new Uint8Array(buffer_1.Buffer.from(message, "utf8"));
    const signatureUint8 = new Uint8Array(buffer_1.Buffer.from(signature, "base64"));
    const pubKeyUint8 = new Uint8Array(buffer_1.Buffer.from(CotterPublicKey, "base64"));
    return tweetnacl_1.sign.detached.verify(messageUint8, signatureUint8, pubKeyUint8);
};
exports.ValidateToken = ValidateToken;
